import React from 'react';
import EntityForm from './EntityForm';

function ManageBrandForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Brand"
            heading="Add New Brand"
            idKey="BrandID"
            insertUrl="insert_manage_brand"
            updateUrl="update_manage_brand"
            deleteUrl="delete_manage_brand"
            fields={[
                { name: 'name', label: 'Name', entryKey: 'Name', required: true },
                { name: 'address', label: 'Address', entryKey: 'Address' },
                { name: 'contact', label: 'Contact', entryKey: 'ContactNo' },
                { name: 'rollorothers', label: 'Roll / Other Accessories', entryKey: 'RollOrOthers', type: 'select', options: ['Roll Code + Others', 'Roll Code', 'Other Accessories'], defaultValue: 'Roll Code + Others' },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageBrandForm;
